import {
  Box,
  Center,
  Heading,
  ModalBody,
  ModalContent,
  ModalHeader,
  VStack,
} from "@chakra-ui/react";
import { type ChainFullId, type UnifiedTokenBalance, getTokenId } from "@umami/chains";
import { useGetNetworkSymbol, useGetTokensAndBalances } from "@umami/state";

import { ModalBackButton } from "../BackButton";
import { ModalCloseButton } from "../CloseButton";
import { TokenMultichain } from "../Token";
import { ShieldedBalanceItem } from "./ShieldedBalanceItem";

type ChainSelectModalProps = {
  onClick: (chainId: ChainFullId, token?: UnifiedTokenBalance) => void;
};

export const ChainSelectModal = ({ onClick }: ChainSelectModalProps) => {
  const { balances, tokens } = useGetTokensAndBalances();
  const getNetworkSymbol = useGetNetworkSymbol();

  return (
    <ModalContent data-testid="chain-select-modal">
      <ModalHeader>
        <ModalBackButton />
        <ModalCloseButton />
        <Center flexDirection="column" gap="12px">
          <Heading size="xl">Send</Heading>
        </Center>
      </ModalHeader>

      <ModalBody>
        <VStack gap="12px" overflowY="auto" maxHeight="400px">
          <ShieldedBalanceItem />
          {balances.map(balance =>
            Number(balance.balance) > 0 ? (
              <Box key={balance.chainId} width="full" onClick={() => onClick(balance.chainId)}>
                <TokenMultichain
                  padding="12px"
                  balance={Number(balance.balance)}
                  chain={balance.chainId}
                  name={getNetworkSymbol(balance.chainId)}
                  usdBalance={balance.totalUsdPrice}
                  usdPrice={balance.usdPrice}
                />
              </Box>
            ) : null
          )}
          {tokens.map(token => (
            <Box key={getTokenId(token)} width="full" onClick={() => onClick(token.chainId, token)}>
              <TokenMultichain padding="12px" token={token} />
            </Box>
          ))}
        </VStack>
      </ModalBody>
    </ModalContent>
  );
};
